module.exports = __webpack_public_path__ + "img/star-icon-leaderboard.3d6a2f2f.svg";